import React, { useEffect, useState } from "react";
import style from "css/mypage.module.css";
import { Empty } from "antd";
import { useTranslation } from "react-i18next";
function Searchbox(props) {
  console.log("SearchBox ", props)
  const [searchword, setsearchword] = useState("");
  const [ghostword, setghostword] = useState("");
  const { t } = useTranslation();

  const [keylist, setkeylist] = useState([]);
  const [orikeylist, setorikeylist] = useState([]);
  const [focus, setfocus] = useState(false);
  const [hover, setHover] = useState(false);
  const [liston, setliston] = useState(false);
  const onchangesearchword = (e) => {
    setsearchword(e.target.value);
    setghostword(e.target.value);
    if (e.target.value.length === 0) {
      setliston(false);
    }
  };
  const resetsearchword = () => {
    setsearchword("");
  };
  useEffect(() => {
    let mdatalist = [];
    if (props.searchset) {
      if (props.type === "common") {
        if (props.data.length > 0) {
          for (let i = 0; i < props.data.length; i++) {
            mdatalist.push({
              label: props.data[i].TITLE,
              value: props.data[i].CONTENTS,
            });
          }
          setorikeylist(mdatalist);
          props.setsearchset();
        }
      } else {
        if (props.data.length > 0) {
          for (let i = 0; i < props.data.length; i++) {
            for (let k = 0; k < props.data[i][1].length; k++) {
              const scheduleData = props.data[i][1][k];
              // 핫데스킹 스케줄
              if (scheduleData.hasOwnProperty("RES_TYPE") && scheduleData.RES_TYPE === 'B') {
                mdatalist.push({
                  label: props.data[i][1][k].LOCATION_DEPARTMENT_TITLE,
                  value: props.data[i][1][k].RESOURCE_TITLE,
                });
              } else {  // 회의실 스케줄
                mdatalist.push({
                  label: props.data[i][1][k].TITLE,
                  value: props.data[i][1][k].CONTENTS,
                });
              }
            }
          }
          setorikeylist(mdatalist);
          props.setsearchset();
        }
      }
    }
  }, [props]);

  const searchmain = () => {
    props.search(searchword);
    setliston(false);
  };

  useEffect(() => {
    let kk = orikeylist;
    setkeylist(kk.filter((data) => filterM(data, ghostword)));
    setliston(true);
  }, [ghostword, orikeylist]);

  const filterM = (data, search) => {
    if (data.label.includes(search) || data.value.includes(search)) {
      return true;
    }
  };

  return (
    <div>
      {/* <div className={hover ? style.searchbox_border_focus : focus ? style.searchbox_border_focus : style.searchbox_border}> */}
      <div className={style.searchbox_border}>
        <div className={style.searchbox_input}>
          <input
            className={style.searchbox_intputtext}
            value={searchword}
            onChange={(e) => onchangesearchword(e)}
            onFocus={() => {
              setfocus(true);
            }}
            onMouseOver={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onBlur={() => setfocus(false)}
            placeholder={t("PLACEHOLDER.SEARCH.TITLE_CONTENT")}
            onKeyDown={(res) => {
              if (res.key === "Enter") {
                searchmain();
              }
            }}
          />
          <div
            className={
              searchword === "" || searchword === null
                ? style.searchbox_delete
                : style.searchbox_delete + " cursor"
            }
            onClick={resetsearchword}
          >
            {searchword === "" || searchword === null ? (
              ""
            ) : (
              <img
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/mypage/close-circle.png"
                }
                alt=""
              />
            )}
          </div>
        </div>
        {/* <div> */}
        {focus ? (
          <img
            src={
              process.env.REACT_APP_CLIENT_URL +
              "img/mypage/search_gg_focus.png"
            }
            alt=""
            onClick={() => searchmain()}
            className="cursor"
            style={{ width: 22, height: 22 }}
          />
        ) : hover ? (
          <img
            src={
              process.env.REACT_APP_CLIENT_URL + "img/mypage/search_gg_over.png"
            }
            alt=""
            onClick={() => searchmain()}
            className="cursor"
            style={{ width: 22, height: 22 }}
          />
        ) : (
          <img
            src={process.env.REACT_APP_CLIENT_URL + "img/mypage/search_gg.png"}
            alt=""
            onClick={() => searchmain()}
            className="cursor"
            style={{ width: 22, height: 22 }}
          />
        )}
        {/* </div> */}
        {liston ? (
          searchword.length === 0 ? (
            <div />
          ) : keylist.length > 0 ? (
            <div className={style.keywordlist + " " + style.scrollbar}>
              {keylist.map((data, index) => (
                <div
                  key={index}
                  className={style.keywordlistdata + " cursor"}
                  onClick={() => {
                    setsearchword(data.label);
                    setliston(false);
                  }}
                >
                  {data.label}
                </div>
              ))}
            </div>
          ) : (
            <div className={style.keywordlist}>
              <Empty description={t("MESSAGE.NO_DATA")} />
            </div>
          )
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}

export default Searchbox;
